import gql from 'graphql-tag';

const UCI_SYNC_MEMBER = gql`
mutation uciSyncMember($memberId: ID!, $background: Boolean ) {
  uciSyncMember (memberId: $memberId, background: $background) 
}
`;

export default UCI_SYNC_MEMBER;